<template>
  <b-row>
    <b-col cols="12">
      <h4 class="sm:mx-0 mb-12 text-5xl d-theme-heading-color">
        Nenhuma reserva para mostrar no momento =(
      </h4>
      <b-img
        fluid
        src="@/assets/images/pages/graphic-1.png"
        alt="Sem Resultados"
      />
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'NoContentReservas',
}
</script>
